var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step5" },
    [
      _c("vue-good-table", {
        attrs: {
          columns: _vm.columns,
          rows: _vm.rows,
          "sort-options": {
            enabled: false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "qty"
                  ? _c("span", [
                      _c("input", {
                        staticClass: "input-number",
                        attrs: {
                          type: "number",
                          step: "1",
                          min: "1",
                          max: props.row.available
                        },
                        on: {
                          change: function(e) {
                            return _vm.someHandler(props.row.id, e.target)
                          }
                        }
                      })
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n      " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n    "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-con" },
        [
          _c("CButton", {
            attrs: { color: "green", text: "Complete" },
            on: { click: _vm.onNextClick }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml20" },
            [
              _c("CButton", {
                attrs: { color: "orange", text: "Back" },
                on: { click: _vm.onBack }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml20" },
            [
              _c("CButton", {
                attrs: { color: "red", text: "Cancel" },
                on: { click: _vm.onCancel }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }